import Select from 'react-select';
import FieldValidationError from './FieldValidationError';
import { createSelectStyles, getSelectMenuPortalTarget, selectThemeProps } from './selectTheme';

const MultiSelect = (props) => {
    const { error, styles, ...rest } = props;

    const multiSelectStyles = createSelectStyles({
        control: (base, state) => ({
            ...base,
            height: "auto",
            minHeight: "3rem",
            alignItems: "flex-start",
            borderColor: state.isFocused ? base.borderColor : base.borderColor,
        }),
        valueContainer: (base) => ({
            ...base,
            flexWrap: "wrap",
            paddingTop: "4px",
            paddingBottom: "4px",
        }),
        multiValue: (base) => ({
            ...base,
            maxWidth: "100%",
        }),
        multiValueLabel: (base) => ({
            ...base,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        ...styles,
    });

    return (
        <>
            <Select
                isClearable
                isMulti
                {...selectThemeProps}
                menuPortalTarget={getSelectMenuPortalTarget()}
                styles={multiSelectStyles}
                {...rest} />
            <FieldValidationError error={error} />
        </>
    );
}

export default MultiSelect;
